var notices = require('../notices')
function init(modal) {

  var send = document.querySelector('[data-notice]');

  if (modal) {
    var modalDiv = document.querySelector('#modal');
    if (modal) {
      send = modalDiv.querySelector('[data-notice]');
    }
  }

  if(send){
    if(send.hasAttribute('data-notice-confirm')){
      notices.confirm(send.dataset.noticeConfirm)
    } else if(send.hasAttribute('data-notice-warn')) {
      notices.warn(send.dataset.noticeWarn)
    }
  }


}

document.addEventListener('DOMContentLoaded', function () {
  init(false)
});
document.addEventListener('modal-loaded', function () {
  init(true)
})